import { useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useResource } from 'src/hooks/useResource'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'
import { format } from 'date-fns'
import Status from './status'

export default function PracticeRow({
  item,
  role,
  active,
  onClick = () => {},
  actions = {},
}) {
  const history = useHistory()
  const { onAssignStudents, onAssignClassrooms } = actions

  const { resourceType } = useResource()

  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const [isDetailsOpen, setIsDetailsOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsMenuOpen(!isMenuOpen)
  }

  const handleDetailsOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDetailsOpen(!isDetailsOpen)
  }

  const goToLesson = () => {
    history.push(`/lessons/${resourceType}/${item.id}/questions`)
  }

  const classroomName = (item.grade?.name ?? '').replace('Kindergarten', 'K')

  return (
    <div
      className={`details-item details-item__${item.color} ${
        isDetailsOpen ? 'active' : ''
      }`}
    >
      <div className="details-item__num  cursor-pointer" onClick={goToLesson}>
        <div className="subject-name">{item.subject?.name}</div>
        <div>{classroomName}</div>
      </div>
      <div className="details-item__top  cursor-pointer" onClick={goToLesson}>
        <span className="details-item__name">{item.title || 'No title'}</span>
        <ul className="details-item__list">
          <li>
            {/* <i className="hb-ico  student-ico"></i> */}
            <span>Students:</span>
            <b>{item.students_count}</b>
          </li>
          <li>
            {/* <i className="hb-ico problems-ico"></i> */}
            <span>Problems:</span>
            <b>
              {item?.filled || '0'} / {item?.problems}
            </b>
          </li>
          <li>
            {/* <i className="hb-ico score-ico"></i> */}
            <span>Scores:</span>
            <b>{item?.scores ? item?.scores : 0}%</b>
          </li>
        </ul>
        <ul
          className="details-item__students"
          style={{ display: isDetailsOpen ? 'block' : 'none' }}
        >
          <li>
            <b>+90%</b>
            {item.stat90} students
          </li>
          <li>
            <b>+80%</b>
            {item.stat80} students
          </li>
          <li>
            <b>+70%</b>
            {item.stat70} students
          </li>
          <li>
            <b>-70%</b>
            {item.stat69} students
          </li>
        </ul>
      </div>

      <div className="details-item__middle" style={{ alignItems: 'center' }}>
        <div className="details-item__btns">
          <a
            href="#"
            className="second-btn cursor-pointer"
            onClick={goToLesson}
          >
            {item.topic?.name}
          </a>
        </div>

        <Status status={item.status} />

        <a
          href="#"
          className="details-link"
          onClick={handleDetailsOpen}
          style={{ bottom: 27 }}
        >
          <i className="hb-ico plus-ico" />
          Details
        </a>
      </div>

      <div
        className="details-item__created"
        style={{ display: isDetailsOpen ? 'block' : 'none' }}
      >
        Created by{' '}
        <b>
          {item.created_by?.first_name} {item.created_by?.last_name}
        </b>
      </div>

      <div
        className="details-item__block"
        style={{ display: isDetailsOpen ? 'block' : 'none' }}
      >
        <div className="details-item__row">
          <div className="details-item__row-wrap">
            <div className="details-item__col">
              <span className="details-item__title">Added</span>
              <p>{format(new Date(item.created_at), 'MMM d')} </p>
            </div>
            <div className="details-item__col">
              <span className="details-item__title">Practithink rating</span>
              <div className="details-item__stars">
                <i className="hb-ico star-ico-5" />
                <span>
                  {item.rating_score} ({item.rating_count})
                </span>
              </div>
            </div>
          </div>
          <div className="details-item__assing">
            <p>Assign this practice to</p>
            <ul>
              <li>
                <a href="#" onClick={onAssignClassrooms(item)}>
                  <i className="hb-ico plusCircle-ico" />
                  Class
                </a>
              </li>
              <li>
                <a href="#" onClick={onAssignStudents(item)}>
                  <i className="hb-ico plusCircle-ico" />
                  Student
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div ref={refMenu} className={`dropHb ${isMenuOpen ? 'active' : ''}`}>
        <a className="dropHb-top" onClick={handleMenuOpen}>
          <i className="hb-ico dots-ico" />
        </a>
        <div className="dropHb-info">
          <ul>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  actions.onEdit(item)
                  setIsMenuOpen(false)
                }}
              >
                <i className="hb-ico edit-ico" />
                Edit
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  actions.onDelete(item)
                  setIsMenuOpen(false)
                }}
              >
                <i className="hb-ico trash-ico" />
                Delete
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  onAssignStudents(item)()
                  setIsMenuOpen(false)
                }}
              >
                <i className="hb-ico assign-ico" />
                Assign
              </a>
            </li>
            {/* <li><a href="#" onClick={(e) => { e.preventDefault(); actions.onSendToMark(item); setIsMenuOpen(false) }}>
              <i className="hb-ico send-ico"></i>
              Send to mark
            </a></li> */}
          </ul>
        </div>
      </div>
    </div>
  )
}
